import global from './global';
import restaurants from './restaurants';
import manufacturers from './manufacturers';
import suppliers from './suppliers';

export default {
  global,
  restaurants,
  manufacturers,
  suppliers,
};
